import { useEffect } from "react";

/**
 * Custom hook to persist UI preferences to localStorage
 * 
 * Manages persistence for:
 * - Theme selection (dark-mode/light-mode)
 * - Active logo (schlage/romanworks)
 * - WebSocket modal preferences
 * - Auto-reconnect settings
 * 
 * @param {string} theme - Current theme
 * @param {string} activeLogo - Current active logo
 * @param {boolean} isModalEnabled - Whether reconnect modal is enabled
 * @param {boolean} isAutoReconnectEnabled - Whether auto-reconnect is enabled
 */
export const useLocalStoragePersistence = (
  theme,
  activeLogo,
  isModalEnabled,
  isAutoReconnectEnabled
) => {
  // Persist theme to localStorage and body className
  useEffect(() => {
    document.body.className = theme;
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Persist active logo to localStorage
  useEffect(() => {
    localStorage.setItem("activeLogo", activeLogo);
  }, [activeLogo]);

  // Persist modal preference to localStorage
  useEffect(() => {
    localStorage.setItem("showReconnectModal", JSON.stringify(isModalEnabled));
  }, [isModalEnabled]);

  // Persist auto-reconnect setting to localStorage
  useEffect(() => {
    localStorage.setItem(
      "autoReconnectWebSocket",
      JSON.stringify(isAutoReconnectEnabled)
    );
  }, [isAutoReconnectEnabled]);
};

export default useLocalStoragePersistence;
